export const syncOfflineSale = async data => {
  return await window.$vue.$post({
    endpoint: "/offline-sale",
    data
  })
}

export const editOfflineSale = async (id, data) => {
  return await window.$vue.$put({ endpoint: `/offline-sale/${id}`, data })
}

export const getIndicators = async params => {
  return await window.$vue.$get({
    endpoint: `/offline-sale/indicators`,
    params
  })
}

export const getListOfflineOrder = async params => {
  return await window.$vue.$get({
    endpoint: "/offline-sale",
    params
  })
}

export const getDetailsOrder = async uuid => {
  return await window.$vue.$get({ endpoint: `/offline-sale/${uuid}` })
}

export const cancelOfflineOrder = async uuid => {
  return await window.$vue.$put({ endpoint: `/offline-sale/${uuid}/cancel` })
}

export const transformOfflineOrder = async uuid => {
  return await window.$vue.$get({ endpoint: `/offline-sale/${uuid}/transform` })
}
